import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBar, MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { ImagePanelComponent } from '@ildes/basic/image-panel/image-panel.component';
import { SimpleHeaderComponent } from '@ildes/basic/simple-header/simple-header.component';
import { AllowActionDirective } from '@ildes/directives/allow-action.directive';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { columns, parse, OPEN_FILE } from './utils';
import { LoadingService } from '@ildes/services/loading.service';
import { FileHelperService } from '@ildes/services/file-helper.service';
const SIZE = 200;

@Component({
  selector: 'app-reporting-manual-reports',
  standalone: true,
  imports: [
    SimpleHeaderComponent,
    MatProgressBarModule,
    ImagePanelComponent,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    RouterModule,
    AllowActionDirective
  ],
  template: `
<div class="container">
    <simple-header title="Otros informes" [back]="true" icon="close"></simple-header>
    <h3>Resultados de búsqueda</h3>
    <mat-progress-bar class="margin-top-16" mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <app-image-panel class="margin-top-16" *ngIf="!parsedItems?.length && !loading"></app-image-panel>
    <div class="container-table" *ngIf="!loading && parsedItems?.length">
        <table [width]="width">
        <tr class="header">
            <th *ngFor="let columnName of header">{{columnName}}</th>
        </tr>
        <tr *ngFor="let row of parsedItems">
            <td *ngFor="let columnValue of row">
            <span *ngIf="!columnValue.config?.link" [innerHTML]="columnValue.value"></span>
            <button (click)="columnAction(columnValue.config.link.action, columnValue.item)" mat-button *ngIf="columnValue.config?.link && columnValue.value">{{columnValue.value}}</button>
            </td>
        </tr>
        </table>
    </div>
    <button [allowAction]="['manualReports.create']" mat-fab color="primary" class="fab-button" [routerLink]="['/app/reports/others/create-report']"><mat-icon>add</mat-icon></button>
    <mat-paginator
        *ngIf="!loading && parsedItems?.length"
        [pageIndex]="currentPage"
        [length]="pagination?.totalDocs"
        pageSize="20"
        (page)="paginate($event)">
    </mat-paginator>
</div>`,
  styleUrls: ['./reporting-manual-reports.component.css'],
})
export class ReportingManualReportsComponent implements OnInit{
    loading;
    parsedItems;
    header;
    columnsConfig;
    items;
    size;
    currentPage;
    pagination;
    downloading;
    constructor(
        public apiManager: ApiManagerService,
        public loadingService: LoadingService,
        public fileHelper: FileHelperService,
    ) {
    
        this.columnsConfig = columns;
        this.header = Object.values(this.columnsConfig).map(({name}) => name);
        this.size = `${SIZE * this.header.length}px`;
    }


    ngOnInit(): void {
        this.list();
    }


    getFilter() {
        return {};
    }
    list(pageIndex = 0) {
        this.currentPage = pageIndex;
        const page = pageIndex ? { page: pageIndex + 1 } : {};
        let filter: any = this.getFilter();
        filter = {...filter}
        this.loading = true;
        this.fetch(page, filter).subscribe((data: any) => {
        this.loading = false;
        this.items = data?.data;
        if (!this.items) {
            this.pagination = null;
            this.parsedItems = null;
            return;
        }
        this.size = `${SIZE * this.header.length}px`;
        this.parsedItems = parse(this.items, this.columnsConfig);
        this.pagination = data.pagination;
        }, () => {
        this.loading = false;
        });
    }

    fetch(page, filter) {
        return this.apiManager.listManualReports({...page, ...filter});
    }

    paginate(event) {
        this.list(event.pageIndex);
    }

    columnAction(action, item) {
        switch (action) {
            case OPEN_FILE:
                this.open(item.filePath);
                break;
        
            default:
                break;
        }
    }

     open(fileName) {
        this.loadingService.show();
        this.downloading = true;
        this.fileHelper.download(fileName).subscribe(() => {
            this.loadingService.hide();
            this.downloading = false;
        }, () => {
            this.loadingService.hide();
            this.downloading = false;
        })
    }
}
